@if (clarifications.length && !dismissed && answered) {
  <div class="clarification-card answered">
    <mat-icon class="answered-icon">check_circle</mat-icon>
    <span class="answered-text">{{ answeredText || ('Answered' | translate) }}</span>
  </div>
}
@if (clarifications.length && !dismissed && !answered) {
  <div class="clarification-card">
    <div class="card-header">
      <div class="card-question">{{ currentClarification?.question }}</div>
      @if (clarifications.length > 1) {
        <div class="card-nav">
          <button type="button" class="nav-btn" [disabled]="currentIndex === 0" (click)="prev()">
            <mat-icon>chevron_left</mat-icon>
          </button>
          <span class="nav-count">{{ currentIndex + 1 }} {{ 'of' | translate }} {{ clarifications.length }}</span>
          <button type="button" class="nav-btn" [disabled]="currentIndex === clarifications.length - 1" (click)="next()">
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
      }
      <button type="button" class="close-btn" (click)="onClose()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="card-body">
      @for (option of currentClarification?.options; track trackByIndex($index)) {
        <label class="card-row">
          <input type="checkbox" [checked]="isOptionSelected(option)" [disabled]="disabled" (change)="toggleOption(option)">
          <span>{{ option }}</span>
        </label>
      }
      @if (currentClarification?.allowFreeText) {
        <label class="card-row freetext-row">
          <span class="freetext-label">{{ 'Something else' | translate }}</span>
          <input type="text" class="freetext-input" [ngModel]="currentAnswer.freeText" (ngModelChange)="setFreeText($event)"
            [disabled]="disabled" [placeholder]="'Or type your own answer…' | translate">
          </label>
        }
      </div>
      <div class="card-footer">
        <span class="selected-count">{{ currentSelectedCount }} {{ 'selected' | translate }}</span>
        <div class="footer-actions">
          <button type="button" class="skip-btn" [disabled]="disabled" (click)="skip()">{{ skipButtonLabel | translate }}</button>
          <button type="button" class="submit-btn" [disabled]="disabled || !canSubmit" (click)="onSubmit()">
            <mat-icon>send</mat-icon>
          </button>
        </div>
      </div>
    </div>
  }
